import * as React from 'react';

const ClimateImpact24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.37 9.525c.782-3.724 4.317-5.846 7.477-5.846a8.153 8.153 0 1 1 0 16.306H6.703c-1.6 0-3.03-.536-4.066-1.52-1.04-.987-1.635-2.382-1.635-4.004 0-2.881 2.3-5.059 4.857-5.059a8.04 8.04 0 0 1 1.512.123Zm7.477-4.347c-2.799 0-5.816 2.025-6.11 5.341a.75.75 0 0 1-.934.66 8.386 8.386 0 0 1-.2-.055c-.363-.103-.783-.222-1.744-.222-1.714 0-3.358 1.491-3.358 3.56 0 1.24.449 2.232 1.169 2.916.724.688 1.77 1.107 3.033 1.107h8.144a6.653 6.653 0 1 0 0-13.307Z",
    clipRule: "evenodd"
  }
));
ClimateImpact24.Size = 24;
ClimateImpact24.Title = "ClimateImpact";

export { ClimateImpact24 as default };
